<template>
  <div id="GowerWebHeader">
    <b-navbar toggleable="md" :type="navType" :variant="navVariant">

      <b-navbar-brand>
        {{ state.title }}
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="float-right"></b-navbar-toggle>

      <!-- Left aligned nav items -->
      <b-navbar-nav class="d-none d-md-flex">
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-none ml-md-auto d-block d-md-flex">

          <b-nav-item class="mr-0 mr-md-2" @click="showHelp" v-if="state.userId && state.helpEnable && !helpLocked">
            Help
          </b-nav-item>

          <b-nav-item class="mr-0 mr-md-2" @click="showFeedbackRequests" v-if="state.userId && state.feedbackEnable && !feedbackLocked">
            Feedback
          </b-nav-item>

          <b-nav-item v-if="state.notificationList && state.notificationList.length && !notificationLocked" class="mr-0 mr-md-2" @click="readNotifications">
            Updates
            <b-badge variant="danger" v-if="state.notificationUnReadCount > 0">{{ state.notificationUnReadCount }}</b-badge>
          </b-nav-item>

          <b-nav-item-dropdown :text="theme || 'No Theme'" right v-if="state.themeList.length && !themeLocked">
            <b-dropdown-item href="#" v-on:click="changeTheme($event, '')">No Theme</b-dropdown-item>
            <b-dropdown-item v-for="theme in state.themeList" v-bind:key="theme" href="#" v-on:click="changeTheme($event, theme)">{{ theme }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="tenantName" right v-if="state.userId && state.tenants.length">
            <b-dropdown-item v-for="tenant in state.tenants" v-bind:key="tenant.id" href="#" v-on:click="changeTenant($event, tenant.id)">{{ tenant.name }}</b-dropdown-item>
          </b-nav-item-dropdown>
          
          <b-nav-item-dropdown class="d-inline-block d-md-flex" v-bind:text="state.userFullName || state.userName" right>
            <b-dropdown-item href="#" v-if="!state.userId" v-on:click="login()">Login</b-dropdown-item>
            <b-dropdown-item href="#" v-if="state.userId" v-on:click="logout()">Logout</b-dropdown-item>
            <b-dropdown-item href="#" v-on:click="changeRender()">{{ this.renderModeToggleDescription }}</b-dropdown-item>
            <b-dropdown-divider v-if="state.userId"></b-dropdown-divider>
            <b-dropdown-item href="#" v-if="state.userId" v-on:click="editPreferences()">Preferences</b-dropdown-item>
            <b-dropdown-item href="#" v-if="state.userId && state.canChangePassword" v-on:click="changePassword()">Change Password</b-dropdown-item>
            <b-dropdown-item href="#" v-if="state.userId" @click="shortenUrl()">Shorten Url</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>

    </b-navbar>
    <b-breadcrumb :items="breadCrumbs" @click="breadCrumbClick" class="d-print-none" />
    <button class="btn btn-primary btn-sm float-right close-button d-print-none" v-if="breadCrumbs.length > 1" @click="closeButtonClick">Close</button>
    <b-alert :show="message.countdown || true" fade v-for="message in headerMessages" :key="message.text" :variant="message.variant || 'danger'" :dismissible="!!message.dismissable">{{ message.text }}</b-alert>

    <b-modal id="modalNotifications" ref="modalNotifications" title="Notifications" size="lg" @ok="hideNotifications" @hide="hideNotifications">
      <div role="tablist">
        <b-card no-body class="mb-1" v-for="notification in state.notificationList" :key="notification.id">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block variant="info" class="text-left" @click="notification.isOpen = !notification.isOpen">
              {{ notification.title }}
              <b-badge variant="danger" class="float-right" v-if="!notification.isRead">New!</b-badge>
            </b-button>
          </b-card-header>
          <b-collapse :id="'notification-' + notification.id.toString()" role="tabpanel" v-model="notification.isOpen">
            <b-card-header>
              <b-card-sub-title class="font-italic"> Sent by {{ notification.createUserFullName }} on {{ formatDate(notification.createDate) }} </b-card-sub-title>
            </b-card-header>
            <b-card-body>
              <b-card-text v-html="formatTextAsHtml(notification.text)"></b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </b-modal>

    <b-modal id="modalFeedbackRequests" ref="modalFeedbackRequests" title="My Feedback" size="lg" @ok="hideFeedbackRequests" @hide="hideFeedbackRequests">
      <b-alert :show="message.countdown || true" fade dismissible v-for="message in modalMessages" :key="message.text" :variant="message.variant || 'danger'">{{ message.text }}</b-alert>
      <div role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block variant="info" class="text-left" @click="newFeedbackRequest.isOpen = !newFeedbackRequest.isOpen">
              Make New Request
            </b-button>
          </b-card-header>
          <b-collapse id="feedback-request-new" role="tabpanel" v-model="newFeedbackRequest.isOpen">
            <b-card-body>
              <h5>Title</h5>
              <input type="text" class="form-control mt-1 mb-2" maxlength="512" v-model="newFeedbackRequest.title">
              <h5>Request</h5>
              <textarea class="form-control mt-1 mb-2" v-model="newFeedbackRequest.text" rows="10"></textarea>
              <button class="btn btn-primary" @click="saveFeedbackRequest(newFeedbackRequest)">Create</button>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1" v-for="feedbackRequest in feedbackRequests" :key="feedbackRequest.id">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block variant="info" class="text-left" @click="feedbackRequest.isOpen = !feedbackRequest.isOpen">
              {{ feedbackRequest.title }}
              <b-badge :variant="feedbackRequest.lookupStatusName === 'New' ? 'success' : 'danger'" class="float-right">{{ feedbackRequest.lookupStatusName }}</b-badge>
            </b-button>
          </b-card-header>
          <b-collapse :id="'feedback-request-' + feedbackRequest.id.toString()" role="tabpanel" v-model="feedbackRequest.isOpen">
            <b-card-header>
              <b-card-sub-title class="font-italic"> Created by {{ feedbackRequest.createUserFullName }} on {{ formatDate(feedbackRequest.createDate) }} </b-card-sub-title>
            </b-card-header>
            <b-card-body>
              <h5>Request</h5>
              <textarea class="form-control mt-1 mb-2" v-model="feedbackRequest.text" rows="10" v-if="feedbackRequest.lookupStatusName === 'New'"></textarea>
              <b-card-text v-if="feedbackRequest.lookupStatusName !== 'New'">{{ feedbackRequest.text }}</b-card-text>
              <h5 v-if="feedbackRequest.devText">Response</h5>
              <b-card-text v-if="feedbackRequest.devText">
                {{ feedbackRequest.devText }}
              </b-card-text>
              <button class="btn btn-primary" @click="saveFeedbackRequest(feedbackRequest)" v-if="feedbackRequest.lookupStatusName === 'New'">Update</button>
            </b-card-body>
            <b-card-footer>
              <b-card-sub-title class="font-italic"> Updated by {{ feedbackRequest.modifyUserFullName }} on {{ formatDate(feedbackRequest.modifyDate) }} </b-card-sub-title>
            </b-card-footer>
          </b-collapse>
        </b-card>
      </div>
    </b-modal>

    <b-modal id="modalUserPreferences" ref="modalUserPreferences" title="User Preferences" size="lg" @ok="updatePreferences" @hide="hidePreferences">
      <b-alert :show="message.countdown || true" fade dismissible v-for="message in modalMessages" :key="message.text" :variant="message.variant || 'danger'">{{ message.text }}</b-alert>
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label>Default Company</label>
            <select class="form-control" v-model="preferences.defaultCompanyId">
              <option v-for="tenant in state.tenants" v-bind:key="tenant.id" v-bind:value="tenant.id">{{ tenant.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Email Address</label>
            <input type="text" class="form-control" maxlength="100" v-model="preferences.emailAddress">
          </div>
        </div>
        <div class="col-md-12">
          <label class="mb-0">Options</label>
          <div class="form-control-plaintext border-0 pl-0">
            <generic-toggle v-model="preferences.useFloatingTableHeaders" label="Use Floating Table Headers"></generic-toggle>
            <generic-toggle v-model="preferences.useLocalDrawingPathByDefault" label="Use Local Drawing Path"></generic-toggle>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Default Page Size</label>
            <select class="form-control" v-model="preferences.defaultPageSize" @change="changePageSize()">
              <option v-for="pageSize in lookups.pageSizes" v-bind:key="pageSize" v-bind:value="pageSize">{{ pageSize }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Floating Table Size</label>
            <select class="form-control" v-model="preferences.floatingTableHeightPixels">
              <option v-for="height in lookups.floatingTableHeights" v-bind:key="height" v-bind:value="height">{{ height }} px</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Phone Number</label>
            <input type="text" class="form-control" maxlength="100" v-model="preferences.phoneNumber">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Default Find Quote Status</label>
            <select class="form-control" v-model="preferences.defaultStatus">
              <option></option>
              <option v-for="status in lookups.statuses" v-bind:key="status.name" v-bind:value="status.name">{{ status.description }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Default Find Quote Estimator</label>
            <select class="form-control" v-model="preferences.lookupDefaultEstimatorId">
              <option v-for="estimator in lookups.estimators" v-bind:key="estimator.id" v-bind:value="estimator.id">{{ estimator.fullName }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Default Find Quote Salesperson</label>
            <select class="form-control" v-model="preferences.lookupDefaultSalesPersonId">
              <option v-for="salesPerson in lookups.salesPeople" v-bind:key="salesPerson.id" v-bind:value="salesPerson.id">{{ salesPerson.fullName }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Default Organization</label>
            <select class="form-control" v-model="preferences.defaultOrganizationId">
              <option></option>
              <option v-for="org in lookups.organizations" v-bind:key="org.id" v-bind:value="org.id">{{ org.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Default Location</label>
            <select class="form-control" v-model="preferences.lookupDefaultLocationId">
              <option v-for="location in lookups.locations" v-bind:key="location.id" v-bind:value="location.id">{{ location.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </b-modal>
    <div class="loader-modal" v-show="loaderVisible">
      <div class="text-center">
        <b-spinner variant="primary" label="Spinning" class="ml-auto" style="width: 10rem; height: 10rem;"></b-spinner>
      </div>
    </div>
    <generic-eliza ref="eliza"></generic-eliza>

    <b-modal id="modalUrl" ref="modalUrl" title="Your Shortened Url" size="md">
      <div class="text-center">
        <p>Your shortened URL is below and has been automatically copied into the clipboard:</p>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="input-group mb-1">
            <input type="text" readonly class="form-control" v-model="shortenedUrl">
            <div class="input-group-append d-print-none">
              <b-button size="md" variant="primary" tag="a" :href="shortenedUrl" _target="blank"><i class="fas fa-link"></i></b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <generic-confirm ref="confirm"></generic-confirm>
  </div>
</template>

<script>
  import GenericEliza from "./eliza.vue"

  export default {
    name: "generic-header",
    components: { GenericEliza },
    mounted() {
      if (window.appState.userName && window.appState.userName !== 'Anonymous') {
        appHelpers.token.setupAutoRefresh(this.postCheck).then(undefined, this.handleExpiration);
      }
      appHelpers.breadCrumbs.init({ text: 'Home', href: `${this.state.relativeBaseUrl}${this.state.currentTenantId}/home` });
      appHelpers.loader.register(this.loader);
      this.statusCheck();
    },
    data() {
      return {
        state: window.appState,
        tenantId: window.appState.currentTenantId,
        tenantName: window.appState.currentTenantName,
        theme: window.appState.theme,
        preferences: window.appState.preferences,
        forceDesktopRender: window.appState.forceDesktopRender,
        headerMessages: [],
        modalMessages: [],
        loaderVisible: false,
        lookups: {
          pageSizes: [ 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 100, 250, 500 ],
          floatingTableHeights: [ 250, 300, 350, 400, 450, 500, 600, 700, 800, 900, 1000 ],
          statuses: [
            { name: "OPEN", description: "Open" },
            { name: "SUBMITTED", description: "Submitted" },
            { name: "ORDERED", description: "Ordered" },
            { name: "CANCELLED", description: "Cancelled" },
            { name: "INACTIVE", description: "Inactive" },
            { name: "REQUOTE", description: "Requote" },
          ],
          salesPeople: [],
          estimators: [],
          organizations: [],
          locations: []
        },
        feedbackRequests: [],
        newFeedbackRequest: {
          title: '',
          text: '',
          isOpen: false
        },
        breadCrumbs: appHelpers.breadCrumbs.all,
        shortenedUrl: null
      };
    },
    computed: {
      navVariant() {
        if (!window.appState.theme || window.appState.theme === '') {
          return 'dark';
        } else {
          switch (window.appState.theme.toLowerCase()) {
            case 'darkly':
            case 'flatly':
            case 'litera':
            case 'sandstone':
              return 'primary';
            case 'superhero':
              return 'light';
            case 'original':
            default:
              return 'dark';
          }
        }
      },
      navType() {
        if (!window.appState.theme || window.appState.theme === '') {
          return 'dark';
        } else {
          switch (window.appState.theme.toLowerCase()) {
            case 'darkly':
            case 'flatly':
            case 'litera':
            case 'sandstone':
            case 'slate':
            case 'solar':
            case 'cyborg':
            case 'materia':
            case 'simplex':
            case 'original':
              return 'dark';
            default:
              return 'light';
          }
        }
      },
      renderModeToggleDescription() {
        return this.forceDesktopRender ? 'Unforce Desktop Render' : 'Force Desktop Render';
      },
      feedbackLocked() {
        return appHelpers.security.hasFunctionLock('header-feedback-request');
      },
      notificationLocked() {
        return appHelpers.security.hasFunctionLock('header-notification');
      },
      themeLocked() {
        return appHelpers.security.hasFunctionLock('header-theme');
      },
      helpLocked() {
        return appHelpers.security.hasFunctionLock('header-help');
      },
    },
    methods: {
      formatDate(value, key, item) {
        return appHelpers.formatters.formatDate(value, key, item);
      },
      formatTextAsHtml(value) {
        return appHelpers.text.replace(value, '\n', '<br/>');
      },
      breadCrumbClick(e) {
        appHelpers.form.hrefCheckDirty(e);
      },
      closeButtonClick() {
        if (this.breadCrumbs && this.breadCrumbs.length > 1) {
          let parentCrumb = this.breadCrumbs[this.breadCrumbs.length - 2];
          
          //Only initiate check if Breadcrumb points to a URL as generic route check will handle the other use case
          if (parentCrumb.href) {
            appHelpers.form.urlCheckDirty(parentCrumb.href);
          } else if (parentCrumb.to) {
            this.$router.push(parentCrumb.to);
          }
        }
      },
      loader(visible) {
        this.loaderVisible = visible;
      },
      handleExpiration(response) {
        window.location = appHelpers.url.fix("/log/out?expired=true");
      },
      postCheck(state) {
        this.headerMessages = [ ];
        this.statusCheck(state);
        if (state.version !== window.appState.version) {
          this.headerMessages.push({ text: 'Your instance of Gower Portal is out of date. Refresh this browser tab.', variant: 'danger', dismissable: false });
          window.scrollTo(0, 0);
        }
      },
      statusCheck(state) {
        state = state || this.state;
        if (state.currentTenantHostStatus != null && state.currentTenantHostStatus.lastChecked && !state.currentTenantHostStatus.isAvailable) {
          this.headerMessages.push({ text: 'AS400 is unavailable as of ' + dayjs(state.currentTenantHostStatus.lastChecked).format('HH:mm:ss') + '! Gower Portal will not function as expected! Refresh your browser tab to get latest status!', variant: 'danger', dismissable: false });
        }
      },
      changeTenant(event, tenantId) {
        window.location = appHelpers.url.fix(`/${tenantId}/home`);
      },
      changeTheme(event, theme) {
        window.location = appHelpers.url.fix(`/ui/theme?selection=${theme}`)
      },
      changeRender(event) {
        window.location = appHelpers.url.fix(`/ui/render?forceDesktopRender=${this.forceDesktopRender ? "" : "1"}`)
      },
      login(event) {
        window.location = appHelpers.url.fix("/log/in");
      },
      changePassword(event) {
        window.location = appHelpers.url.fix("/password/change");
      },
      logout(event) {
        window.location = appHelpers.url.fix("/log/out");
      },
      readNotifications(event) {
        appHelpers.loader.start();
        let promises = [ ];
        let maxNotificationId = this.state.notificationList[0].id;
        if (maxNotificationId > this.state.notificationMaxRead) {
          promises.push(apiClient.notification.read(maxNotificationId));
          this.state.notificationMaxRead = maxNotificationId;
          this.state.notificationUnReadCount = 0;
        } else {
          for (var notificationIndex in this.state.notificationList) {
            this.state.notificationList[notificationIndex].isRead = true;
          }
        }
        Promise.all(promises).then(() => {
          if (promises.length) {
            appHelpers.audit.logEntityAction('Read', 'Notifications');
          }
          this.$refs.modalNotifications.show();
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
      hideNotifications(event) {
        if (event.trigger === 'backdrop') {
          event.preventDefault();
        }
      },
      clearFeedbackRequest() {
        this.newFeedbackRequest = {
          title: '',
          text: '',
          isOpen: false
        };
      },
      showFeedbackRequests(event) {
        this.modalMessages = [];
        appHelpers.loader.start();
        this.clearFeedbackRequest();
        apiClient.feedback.request.getMine(this.state.currentTenantId)
          .then((response) => {
            this.feedbackRequests = response.body;
            this.$refs.modalFeedbackRequests.show();
          }).finally(() => {
            appHelpers.loader.stop();
          });
      },
      hideFeedbackRequests(event) {
        if (event.trigger === 'backdrop') {
          event.preventDefault();
        }
      },
      saveFeedbackRequest(feedbackRequest) {
        this.modalMessages = [];
        return apiClient.feedback.request.upsert(this.state.currentTenantId, feedbackRequest)
          .then(result => {
            appHelpers.audit.logEntityAction(feedbackRequest.id ? 'Updated' : 'Created', 'Feedback Request', feedbackRequest.id);
            this.showFeedbackRequests();
          }, result => {
            this.modalMessages = appHelpers.message.getFromResponse(result);
            event.preventDefault();
          });
      },
      editPreferences(event) {
        appHelpers.loader.start();
        Promise.all([
          apiClient.lookup.getMultipleEntries(this.state.currentTenantId, [
            [ 'salesperson', 'salesPeople', this.preferences.lookupDefaultSalesPersonId, true ],
            [ 'estimator', 'estimators', this.preferences.lookupDefaultEstimatorId, true ],
            [ 'location', 'locations', this.preferences.lookupDefaultLocationId, true ],
          ]),
          apiClient.organization.get(null, false),
        ]).then(result => {
          this.lookups.salesPeople = result[0].body.salesPeople;
          this.lookups.estimators = result[0].body.estimators;
          this.lookups.locations = result[0].body.locations;
          this.lookups.organizations = result[1].body;
          this.$refs.modalUserPreferences.show();
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
      hidePreferences(event) {
        if (event.trigger === 'backdrop') {
          event.preventDefault();
        }
      },
      updatePreferences(event) {
        this.modalMessages = [];
        return apiClient.user.updatePreferences(this.state.userId, this.preferences)
          .then(result => {
            appHelpers.audit.logEntityAction('Updated', 'User Preferences', this.state.userId);
            window.appState.preferences = result.body;
          }, result => {
            this.modalMessages = appHelpers.message.getFromResponse(result);
            event.preventDefault();
          });
      },
      showHelp() {
        this.$refs.eliza.show();
      },
      shortenUrl() {
        this.headerMessages = [ ];
        let target = window.location.href;
        apiClient.url.shorten(target).then(result => {
          appHelpers.audit.logEntityAction('Created', 'Shortened Url');
          this.shortenedUrl = result.body.shortenedUrl;

          var node = document.createElement("span");
          node.appendChild(document.createTextNode(this.shortenedUrl));
          document.body.appendChild(node);
          var range = document.createRange();
          var selection = window.getSelection();
          selection.removeAllRanges();
          range.selectNodeContents(node);
          selection.addRange(range);
          document.execCommand('copy');
          selection.removeAllRanges();
          node.remove();
          event.preventDefault();

          this.$refs.modalUrl.show();
        }, result => {
          this.headerMessages = appHelpers.message.getFromResponse(result);
          event.preventDefault();
        })
      },
      changePageSize() {
        if (this.state.preferences.defaultPageSize > 100) {
          return this.$refs.confirm.confirm('If you experience performance problems when interacting with tables, please change this setting back to 100 or less.', { okOnly: true, title: 'Warning: Possible Performance Problems' }).then(() => {
            //Let it ride
          });
        }
      }
    },
  };
</script>

<style>
  .loader-modal {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    padding-top: 45vh;
    background-color: black;
    opacity: 0.8;
    z-index: 2000;
  }

  .close-button {
    z-index: 10;
    position: relative;
    bottom: 57px;
    right: 10px;
    margin-bottom: -57px;
  }
</style>